<template>
  <b-card>
    <b-row>
      <b-col cols="12">
        <h4 class="sm:mx-0 mx-1 mb-12 text-5xl d-theme-heading-color">
          Ainda não existe uma assembleia...
        </h4>
        <b-img
          fluid
          src="@/assets/images/pages/graphic-1.png"
          alt="Sem Resultados"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'NoContentAssembleia',
}
</script>
